export default "__VITE_ASSET__wEge2ixU__"